<mat-card class="h-full">
  <mat-card-title class="py-2">
    <div class="flex align-baseline is-justify-content-space-between">
      <h3 class="f-item m-0">Top performing groups</h3>
      <h3 class="f-item m-0 text-end">Share/user</h3>
    </div>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div *ngIf="topPerformingGroups" class="top-performing-groups-container">
      <div *ngIf="topPerformingGroups.length <= 0" class="text-center p-7">
        {{ loadingText }}
      </div>
      <div
        *ngFor="let group of topPerformingGroups"
        class="top-performing-groups"
      >
        <div class="group-information">
          <p class="bold m-0">{{ group.title }}</p>
          <small
            >{{ group.invites }} invite(s) has shared
            {{ group.unique_shares }} time(s)</small
          >
        </div>
        <div>
          {{ group.share_per_user | formatNumber | roundNumber: 2 }}
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
